// For LDP New Relic Page view table we want to track some custom metrics
// they should be coming here

MOVE.LDP.NrCustomPageViewTracking = (function (LDP) {

var init = function () {
  if ( typeof(window.newrelic) !== 'undefined' && !!(MOVE_DATA.propertyDetails)) {
    window.newrelic.setCustomAttribute('property_type', MOVE_DATA.propertyDetails.property_status);
  }
};

 LDP.NrCustomPageViewTracking =
 {
     init: init
 };

 return LDP.NrCustomPageViewTracking;

})(MOVE.LDP || {});



// WEBPACK FOOTER //
// ./ldp/common_platform/critical_components/_nr_custom_page_view_tracking.js